import { render, staticRenderFns } from "./LayoutSidebar.vue?vue&type=template&id=f667f450&scoped=true"
import script from "./LayoutSidebar.vue?vue&type=script&lang=js"
export * from "./LayoutSidebar.vue?vue&type=script&lang=js"
import style0 from "./LayoutSidebar.vue?vue&type=style&index=0&id=f667f450&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f667f450",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f667f450')) {
      api.createRecord('f667f450', component.options)
    } else {
      api.reload('f667f450', component.options)
    }
    module.hot.accept("./LayoutSidebar.vue?vue&type=template&id=f667f450&scoped=true", function () {
      api.rerender('f667f450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/LayoutSidebar.vue"
export default component.exports